import {Controller} from '@hotwired/stimulus';
import {application} from 'src';
import {addClass, find, removeClass} from '@fretadao/f-js-dom';
import axios from 'axios';

application.register('communication-channel', class extends Controller {
  static targets = [ "template", "templateItem" ];

  connect() {
    // this approach is related to select2
    // https://github.com/select2/select2/issues/4686#issuecomment-264747428
    $(this.templateTarget).on('change', this.changeTemplate.bind(this));
  }

  changeTemplate() {
    const selectedTemplateId = `template-items-${this.templateTarget.value}`;

    this.templateItemTargets.forEach((elem) => {
      if (elem.id == selectedTemplateId) {
        removeClass(elem, 'hide');
      } else {
        addClass(elem, 'hide');
      }
    });
  };
});
